<template>
    <div>
        <div class="form-group">
            <page-title :title="$t('scheduler.agenda')"></page-title>
        </div>

        <div class="loader" v-show="loading"></div>
        <hall-agenda ref="agendaGrid"
                     v-show="!loading"
                     :showSettingsBtn="false"
                     :showBtns="true"
                     @editBtnClick="onEditClicked"
                     @deleteBtnClick="onHallEventDelete">
        </hall-agenda>

        <EditModal v-model="hallEventModel"
                   :show="showEdit"
                   @onClose="onEditClose"
                   @onSave="onHallEventEdit"
                   @onDelete="onHallEventDelete">
        </EditModal>
    </div>
</template>

<script>
    import HallAgenda from '../../components/scheduler/HallAgenda';
    import PageTitle from '../../components/common/PageTitle';
    import EditModal from '../../components/scheduler/edit.modal';
    import agendaService from '../../services/agenda.service';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            details: {
                type: Boolean,
                default: false
            },
        },
        components: {
            HallAgenda,
            PageTitle,
            EditModal
        },
        data() {
            return {
                loading: false,
                hallEventModel: null,
                showEdit: false,
            }
        },
        methods: {
            onHallEventDelete(item) {
                if (!this.claims.agenda.delete) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('scheduler.deleteConfirm')} '${item.title}'?`)
                    .then(function () {
                        this.doDelete(item);
                    }.bind(this));
            },
            doDelete(item) {
                agendaService
                    .delete(item.id)
                    .then(response => {
                        this.loading = false;
                        this.refresh();

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });
                    })
                    .catch(error => {
                        this.loading = false;

                        let statusCode = this.$helpers.errorStatusCode(error);
                        if (statusCode === 403) {
                            this.accessDenied();
                            return;
                        }

                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            onEditClicked(item) {
                if (!this.claims.agenda.update) {
                    return this.$router.push(`/unauthorized`);
                }

                agendaService
                    .getById(item.id)
                    .then(response => {
                        this.hallEventModel = response.data.model;
                        this.showEdit = true;
                    })
                    .catch(error => {
                        this.hallEventModel = null;
                        this.showEdit = false;

                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            onEditClose() {
                this.hallEventModel = null;
                this.showEdit = false;
            },
            onHallEventEdit() {
                this.hallEventModel = null;
                this.showEdit = false;
                this.refresh();
            },
            refresh() {
                let g = this.$refs.agendaGrid;
                if (g) {
                    g.refresh();
                }
            }
        },
        mounted() {

        },
        computed: {
            ...mapGetters(['claims']),
        }
    }
</script>

<style scoped>
</style>
